import { useDeskBookingRequest } from "../../../../api/grpc/desk/useDeskBookingRequest";
import useGrpcQuery from "../../../../lib/hooks/useGrpcQuery";

import {
  ListDeskBookingRequest,
  ListDesksResponse,
} from "../../../../api/grpc/desk/desk";

export const useDeskReservations = () => {
  const { listDeskBooking } = useDeskBookingRequest();

  const {
    loading: loadingDesk,
    error: errorDesk,
    data: deskData,
    refetch: refetchDesk,
  } = useGrpcQuery<ListDeskBookingRequest, ListDesksResponse>({
    method: listDeskBooking,
    variables: {
      accountID: "",
      customerID: "",
    },
    refetchOnWindowFocus: true,
    refetchOnWindowFocusThreshold: 30000,
  });

  return {
    loadingDesk,
    errorDesk,
    deskData,
    refetchDesk,
  };
};
